// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input_inputContainer__1OSHO {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 0.25rem;
}
.Input_inputContainer__1OSHO.Input_disabled__Odmhn {
  opacity: 0.6;
  cursor: not-allowed;
}

.Input_label__U9NhE {
  font-weight: 500;
  font-size: var(--font-size-smaller);
  color: var(--color-text-subtle);
}

.Input_input__k5Ctk {
  width: 100%;
  min-height: 2.5rem;
  padding: 0.5rem 0.875rem;
  background: var(--color-surface-interactive);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-default, 0.25rem);
  transition: border-color 0.15s;
}
.Input_input__k5Ctk:hover {
  border-color: var(--color-border-highlight);
}
.Input_input__k5Ctk:focus, .Input_input__k5Ctk:focus-visible {
  outline: none;
  border-color: var(--color-border-active);
}
.Input_input__k5Ctk::placeholder {
  color: var(--color-text-subtle);
  font-weight: 400;
}
.Input_input__k5Ctk:disabled {
  background-color: var(--color-surface-darker);
  cursor: not-allowed;
}

.Input_required__l5Td8 {
  color: var(--color-destructive, #e53e3e);
  margin-left: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Input/Input.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AACF;AACE;EACE,YAAA;EACA,mBAAA;AACJ;;AAGA;EACE,gBAAA;EACA,mCAAA;EACA,+BAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,4CAAA;EACA,qCAAA;EACA,6CAAA;EACA,8BAAA;AAAF;AAEE;EACE,2CAAA;AAAJ;AAGE;EACE,aAAA;EACA,wCAAA;AADJ;AAIE;EACE,+BAAA;EACA,gBAAA;AAFJ;AAKE;EACE,6CAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,wCAAA;EACA,oBAAA;AAJF","sourcesContent":[".inputContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  gap: 0.25rem;\n\n  &.disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.label {\n  font-weight: 500;\n  font-size: var(--font-size-smaller);\n  color: var(--color-text-subtle);\n}\n\n.input {\n  width: 100%;\n  min-height: 2.5rem;\n  padding: 0.5rem 0.875rem;\n  background: var(--color-surface-interactive);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-default, 0.25rem);\n  transition: border-color 0.15s;\n\n  &:hover {\n    border-color: var(--color-border-highlight);\n  }\n\n  &:focus, &:focus-visible {\n    outline: none;\n    border-color: var(--color-border-active);\n  }\n\n  &::placeholder {\n    color: var(--color-text-subtle);\n    font-weight: 400;\n  }\n\n  &:disabled {\n    background-color: var(--color-surface-darker);\n    cursor: not-allowed;\n  }\n}\n\n.required {\n  color: var(--color-destructive, #e53e3e);\n  margin-left: 0.25rem;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `Input_inputContainer__1OSHO`,
	"disabled": `Input_disabled__Odmhn`,
	"label": `Input_label__U9NhE`,
	"input": `Input_input__k5Ctk`,
	"required": `Input_required__l5Td8`
};
export default ___CSS_LOADER_EXPORT___;
